import { t } from 'i18next';
import ShiftTimePicker from './ShiftTimePicker';
import UpdateSchedule from './Modals/UpdateSchedule';
import FunctionalitySchedule from '../../Functionality/FunctionalityShedule';
import { permissionObj } from '../../../../../../Helpers/permission';
import {EditIcon, TrashOutlineIcon, AddIcon, PersonChipBlack} from '../../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../../components/buttons/ButtonIcon';
import NotInformation from '../../../../../../components/NotInformation';
import CustomButtonLink from '../../../../../../components/buttons/CustomButtonLink';
import ButtonAction from '../../../../../../components/buttons/ButtonAction';
import DeleteModal from '../../../../../Modals/DeleteModal';
import {userDataTransformSupervisor, userListToLabelEmailPhoneValue} from "../../../../../../Apis/functions";
import CreateDepartmentPolicy from "./Modals/CreateDepartmentPolicy";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ScheduleSection = ({ registerAction }) => {
    //function to get the functionality of schedule section
    const {
        searchResults,
        handleCreate,
        handleUpdate,
        handleRemoveSchedule,
        showDeleteModal,
        setShowDeleteModal,
        showCreateModal,
        setShowCreateModal,
        showUpdatedModal,
        setShowUpdatedModal,
        item,
        selectedIds,
        DEV,
        permission,
        setModified,
        setItem,
        handleDeleteSchedules,
        setSelectedIds
    } = FunctionalitySchedule({ registerAction });

    return (
        <>
            <div className='row px-0'>
                <div className='col-12 col-md-3 my-3'>
                {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_CREATE)) && (
                    <ButtonAction
                        id='btn_ss_create_new_department_policy'
                        Icon={AddIcon}
                        name={'create_new_department_policy'}
                        className='btn-outlined-secondary-600-00'
                        iconProps='btn-icon-svg-20px icon-color-secondary-600'
                        onClick={(e) => {setShowCreateModal(true)}}
                        splitName={false}
                    />
                      )}
                </div>
                {searchResults?.length > 0 ? (
                    <>
                        {searchResults?.map((item, index) => {
                            const selectedList = item?.supervisors?.length > 0 ?
                                userListToLabelEmailPhoneValue(userDataTransformSupervisor(item?.supervisors), 'userId', true, PersonChipBlack)
                                : [];
                            return <>
                                <div className='d-flex justify-content-between align-items-center my-4'>
                                    <h5 className='ibl-h5 font-color-general-950 ibl-font-w-600'>
                                        {index === 0
                                            ? t('default_departments_policy')
                                            : `${t('departments_policy')} ${index.toString().padStart(2, '0')}`}
                                    </h5>

                                    <div className='d-flex align-items-center gap-3 align-self-stretch'>
                                        {(DEV ||
                                            permission?.includes(
                                                permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_UPDATE,
                                            )) &&

                                                <ButtonIcon
                                                    id={`btn_ss_update_${item?.id}`}
                                                    Icon={EditIcon}
                                                    title={'update'}
                                                    className='btn-icon-export'
                                                    iconProps='btn-icon-svg-12px icon-color-general-00'
                                                    onClick={() => {
                                                        handleUpdate(item);
                                                    }}
                                                />
                                            }

                                        {(DEV ||
                                            permission?.includes(
                                                permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_DELETE,
                                            )) &&
                                            item?.departmentId != null && (
                                                <ButtonIcon
                                                    id={`btn_ss_delete_${item?.id}`}
                                                    Icon={TrashOutlineIcon}
                                                    className='btn-icon-delete'
                                                    iconProps='btn-icon-svg-12px icon-color-general-00'
                                                    title={'delete'}
                                                    onClick={() => {
                                                        handleRemoveSchedule(item);
                                                    }}
                                                />
                                            )}
                                    </div>
                                </div>

                                <div className='row px-0'>
                                    <ShiftTimePicker
                                        readOnly={true}
                                        item={item}
                                        displayNone={!item?.departmentId}
                                        selectedList={selectedList}
                                    />
                                </div>
                            </>
                        })}
                    </>
                ) : (
                    <NotInformation className={"mt-4"} card={true}>
                        <div className={'warning-text'}>
                            <p>{t('you_have_not_created_department_schedule_yet')}</p>
                        </div>
                        {(DEV ||
                            permission?.includes(permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_CREATE)) && (
                            <CustomButtonLink
                                splitName={false}
                                id={'btn_ss_create_department'}
                                card={true}
                                onClick={(e) => {
                                    handleCreate(e);
                                }}
                                name={'create_new_department_schedule'}
                            />
                        )}
                    </NotInformation>
                )}
            </div>

            {showDeleteModal && (
                <DeleteModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    onClickFn={handleDeleteSchedules}
                    title_modal='delete'
                    description='are_you_sure_you_want_to_delete'
                    data={selectedIds}
                    element_modal='items'
                    isReset={setSelectedIds}
                />
            )}

            {showCreateModal && (
                <CreateDepartmentPolicy
                    show={showCreateModal}
                    onHide={() => setShowCreateModal(false)}
                    setModified={setModified}

                />
            )}

            {showUpdatedModal && (
                <UpdateSchedule
                    show={showUpdatedModal}
                    onHide={() => setShowUpdatedModal(false)}
                    setModified={setModified}
                    item={item}
                    setItem={setItem}
                />
            )}
        </>
    );
};

export default ScheduleSection;
